import React, { useEffect, useState } from 'react'
import { Table } from 'react-feather';
import { ErrorToast, SuccessToast, UpdatedToast } from '../../views/ToastComponent';
import { Api_Url } from '../../config/config';
import { useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from 'antd';

function AddExpenses() {

    const location = useLocation()

    const { state } = location;

    const { id } = useParams()


    const [expenseData, setExpenseData] = useState([])
    const [shouldShowEditBtn, setshouldShowEditBtn] = useState(false);


    const handleValueChange = (index, value) => {
        const newExpenseData = [...expenseData];
        newExpenseData[index].amount = value.target.value;
        setExpenseData(newExpenseData);
    };

    // const BuisnessProfileId = JSON.parse(sessionStorage.getItem("businessPd"))?.

    const AllDataFetchFunc = async () => {
        let response;
        try {
            response = await axios.get(`${Api_Url}api/v1/PdExpense/getby/${state.profileId}/${id}/${state.ProfileId}`, {
                headers: {
                    Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
                }
            });

            const transformedData = response.data.data.map(item => ({
                ...item,
                expenseTypeId: item.id,
                expenseTypes: {
                    expenseTypeId: item.id
                }
            }));
            setExpenseData(transformedData);
            setshouldShowEditBtn(transformedData?.[0]?.isNew)
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        AllDataFetchFunc()
    }, [])

    const [pdExpenseData, setPdExpenseData] = useState({
        "businessPdProfileId": state.profileId,
        "businessId": id,
        "expenseTypes": [],
        "latitude": "",
        "longitude": ""
    })

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {

                const { latitude, longitude } = position.coords;
                setPdExpenseData({ ...pdExpenseData, latitude: latitude.toString(), longitude: longitude.toString(), expenseTypes: expenseData });
            });
        } else {
        }
    }, [expenseData])

    const handleSubmit = async () => {
        let response;
        try {
            response = await axios.post(`${Api_Url}api/v1/PdExpense/with-array`, pdExpenseData, {
                headers: {
                    Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
                }
            })

            if (response.data.succeeded)
                SuccessToast("changed Successfully")
            AllDataFetchFunc()
        } catch (error) {
            ErrorToast("Something went wrong")
        }
    }

    // Handle Update Function 

    const [updateData, setUpdateData] = useState({
        "id": 0,
        "expenses": [],
        "latitude": "",
        "longitude": ""
    })


    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {

                const { latitude, longitude } = position.coords;
                setUpdateData({ ...updateData, latitude: latitude.toString(), longitude: longitude.toString(), expenses: expenseData });
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, [expenseData])

    const handleUpdate = async () => {
        let response;
        try {
            response = await axios.post(`${Api_Url}api/v1/PdExpense/bulk-update`, updateData, {
                headers: {
                    Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
                }
            })
            if (response.data.succeeded) {
                UpdatedToast("Successfully Updated")
                AllDataFetchFunc()
            }
        } catch (error) {
            ErrorToast("Something went wrong")
        }
    }

    const changeValue = () => {

        const UpdatedExpense = expenseData.map((item) => ({
            ...item,
            isNew: true
        }))
        setExpenseData(UpdatedExpense)
    }

    return (
        <>
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className='d-flex justify-content-end mb-3'>
                        <Button onClick={changeValue}>Edit</Button>
                    </div>

                    <div className='container'>
                        <div className='row d-flex flex-column justify-content-center align-items-center'>
                            {
                                expenseData && expenseData.map((item, index) => {
                                    return (
                                        <div className='col-12'>
                                            <div class="card">
                                                <div class="card-body">
                                                    <h5 class="card-title">{item.descriptionText}</h5>
                                                    <p class="card-text">{item.name}</p>
                                                    <input type="number" value={item.amount} onChange={value => handleValueChange(index, value)} disabled={!item.isNew} />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            {shouldShowEditBtn ? (
                                <Button type="primary" onClick={handleSubmit}>Submit</Button>
                            ) : (
                                <Button className='btn btn-dark' type="default" onClick={handleUpdate}>Update</Button>
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default AddExpenses